export default function FloatingChatButton({ chatOnline, setOpenChatWindow }) {
  return (
    <nav aria-label="floating chat button">
      <button
        className={`fixed bottom-8 right-12 block border-2 shadow-sm rounded-full overflow-hidden z-[500] ${
          chatOnline ? "border-ui-blue" : "border-ui-red"
        }`}
        onClick={() => setOpenChatWindow(true)}
      >
        <div
          className={`flex justify-center items-center bg-white hover:text-white px-4 py-2 ${
            chatOnline
              ? "text-ui-blue hover:bg-ui-blue"
              : "text-ui-red hover:bg-ui-red"
          }`}
        >
          <svg
            className="ui-icon w-5 h-5"
            focusable="false"
            aria-hidden="true"
            role="presentation"
          >
            <use href="#ui-icon-chat-solid"></use>
          </svg>
          <h3 className="px-2 bold">
            Chat {chatOnline ? "Online" : "Offline"}
          </h3>
        </div>
      </button>
    </nav>
  );
}
